import "./tabsHomePage.css"
import React, { useState, useEffect, useContext, useRef } from 'react'
import { Routes, Route, useNavigate } from 'react-router-dom'
import { TabContext, TabList } from '@mui/lab'
import { Tab, Grid, useMediaQuery, Chip, Avatar, Menu, IconButton, ListItem, ListItemButton, ListItemText, Tooltip, } from '@mui/material'
import Go from '../../pages/go'
import Master from '../../pages/master'
import ContainerControl from '../../pages/containerControl'
import ScrollToTop from "react-scroll-to-top"
import { useTranslation } from "react-i18next"
import DashboardV1 from "../dashboardV1/dashboardV1"
import CloseIcon from '@mui/icons-material/Close'
import PushPinIcon from '@mui/icons-material/PushPin'
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined'
import { M_Button, NavigateContext, LoadingContext, BufferService } from "src/M_Components"
import GenericEntity from '../../pages/GENERICENTITY/genericEntity'
import { SettingsPage } from "../settings/SettingsPage"
import M_LateralMenu from "src/M_Components/M_LateralMenu/M_LateralMenu"
import { LeavingPageModal } from "../utils/LeavingPageModal"
import { menuObject } from "./menuObject"
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import UserMobileSettings from "../utils/userMobileSettings"
import { useGenericEntityMenu } from '../genericEntity/hooks/useGenericEntityMenu'
import { ArrowRight, Logout, Settings } from "@mui/icons-material"
// import { useGenericEntityMenu } from '../genericEntity/hooks/useGenericEntityMenu'

export default function TabsHomePage({ roles, initialTabs = [], tablesOrder = [], onTablesOrderUpdate }) {

    const { t, i18n } = useTranslation()
    const navigate = useNavigate()
    const ctx = useContext(LoadingContext)
    const matches = useMediaQuery('(max-width: 750px)')
    const pinTabService = new BufferService('OpenTabs/pin')
    const unpinTabService = new BufferService('OpenTabs/unpin')
    const saveOrderService = new BufferService('OpenTabs/saveOrder')
    const updateFiltersService = new BufferService('OpenTabs/updateFilters')
    const tempMenu = (menuObject)

    // Drag and drop state
    const [draggedTab, setDraggedTab] = useState(null)
    const [isLeavingModalOpen, setIsLeavingModalOpen] = useState(false)
    const leavingActionRef = useRef(null)

    //UserAccount Menu
    const [accountName, setAccountName] = useState("")
    const [accountCompany, setAccountCompany] = useState("")
    const [showMenu, setShowMenu] = useState(false)
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null)
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)

    // ✨ ENTIDADES DINÂMICAS DO BACKEND
    const { entities: geEntities, loading: geLoading, refreshMenu: refreshGEMenu } = useGenericEntityMenu()

    const menuRoles = (data) => {
        const tempMenus = data
        const tempRoles = roles.filter(obj => obj.includes('List')).map(obj => obj.replace('List', '').toUpperCase())
        const tempMenuArray = []
        tempMenus?.forEach(obj => {
            // ⚠️ TRATAMENTO ESPECIAL PARA GENERIC ENTITY
            if (obj.tableName === 'GENERICENTITY') {
                // Verificar se tem permissão Admin ou User
                const hasAdminPermission = roles.some(role => 
                    role.toLowerCase().includes('genericentity') && role.toLowerCase().includes('admin') && role.toLowerCase().includes('list')
                )
                const hasUserPermission = roles.some(role => 
                    role.toLowerCase().includes('genericentity') && role.toLowerCase().includes('user') && role.toLowerCase().includes('list')
                )
                
                // Se não tiver nenhuma permissão, não mostrar menu
                if (!hasAdminPermission && !hasUserPermission) {
                    return;
                }
                
                const baseSubMenus = []
                
                // Admin Config só aparece para Admin
                if (hasAdminPermission) {
                    baseSubMenus.push({
                        subMenuLabel: "AdminConfig",
                        subMenuDisplay: t("Configuration") || "Configuration",
                        tableName: "GENERICENTITY_ADMIN",
                        subMenuUrl: "genericentity/admin",
                        subSubMenus: []
                    })
                }
                
                // Adicionar entidades se houver (após carregamento)
                if (!geLoading && geEntities.length > 0) {
                    baseSubMenus.push(...geEntities.map(entity => ({
                        ...entity,
                        // Usar tradução do i18n se disponível
                        subMenuDisplay: entity._captions?.[i18n.language] || entity.subMenuDisplay
                    })))
                }
                
                // Só adicionar ao menu se houver itens para mostrar
                if (baseSubMenus.length > 0) {
                    obj.subMenus = baseSubMenus
                    tempMenuArray.push(obj)
                }
                return; // Sair cedo para evitar processamento adicional
            }
            
            if (obj?.subMenus && obj?.subMenus?.length > 0) {
                const tempSubMenus = obj?.subMenus?.filter(resObj => {
                    if (resObj.tableName) {
                        // Disable role validation for TransportClause
                        return resObj.tableName.toUpperCase() === 'TRANSPORTCLAUSE' || tempRoles.includes(resObj.tableName.toUpperCase())
                    } else {
                        return resObj.subSubMenus && resObj.subSubMenus.length > 0
                    }
                })
                if (tempSubMenus.length > 0) {
                    obj.subMenus = tempSubMenus
                    tempMenuArray.push(obj)
                }
            } else {
                if (tempRoles.includes(obj.tableName.toUpperCase())) {
                    tempMenuArray.push(obj)
                }
            }
        })
        return tempMenuArray
    }

    //lateralMenu
    const [menus, setMenus] = useState(menuRoles(tempMenu))

    // Recalcular menus quando entidades do GE carregarem ou idioma mudar
    useEffect(() => {
        setMenus(menuRoles(tempMenu))
    }, [i18n.language, geEntities, geLoading])

    const handleLogout = () => {
        // console.log('teste handle logout')
        setShowMenu(false)
        localStorage.clear()
        sessionStorage.clear()
        navigate(`/login`)
    }

    //tabs
    const [selectedTab, setSelectedTab] = useState('menu')
    const [tabs, setTabs] = useState([])
    const [tabIndex, setTabIndex] = useState(1)
    const [showButtons, setButtons] = useState(true)
    const [isFirstTime, setIsFirstTime] = useState(true)

    //menu favorites
    const [anchorEl] = useState(null)
    const open = Boolean(anchorEl)

    useEffect(() => {
        if (initialTabs && initialTabs.length > 0) {
            const convertedTabs = initialTabs
                .sort((a, b) => a.TabOrder - b.TabOrder)
                .map((tab, index) => ({
                    value: `${index + 1}`,
                    label: tab.Label,
                    tabUrl: tab.PageUrl,
                    dbId: tab.Id,
                    filters: tab.Filters
                }))

            setTabs(convertedTabs)
            setTabIndex(convertedTabs.length + 1)
            sessionStorage.setItem('tabs', JSON.stringify(convertedTabs))
            sessionStorage.setItem('tabIndex', convertedTabs.length + 1)

            // Restore filters for each tab from database
            convertedTabs.forEach(tab => {
                if (tab.filters) {
                    restoreTabFilters(tab.value, tab.filters)
                }
            })

            // Verificar se o selectedTab atual existe nas novas tabs
            const currentSelected = sessionStorage.getItem('selectedTab')
            if (currentSelected) {
                const parsedSelected = JSON.parse(currentSelected)
                const tabExists = parsedSelected === 'menu' ||
                    convertedTabs.some(t => t.value === parsedSelected)
                if (!tabExists) {
                    setSelectedTab('menu')
                    sessionStorage.setItem('selectedTab', JSON.stringify('menu'))
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialTabs])

    // eslint-disable-next-line
    useEffect(() => {
        const name = localStorage.getItem(`accountName`)
        const company = localStorage.getItem(`accountCompany`)
        if (name !== null && company !== null) {
            setAccountName(name)
            setAccountCompany(company)
        }
    })

    useEffect(() => {
        const tbs = sessionStorage.getItem('tabs')
        const sltbs = sessionStorage.getItem('selectedTab')
        const swbts = sessionStorage.getItem('showButtons')
        const tabIndx = sessionStorage.getItem('tabIndex')

        if (tbs !== null && sltbs !== null && swbts !== null) {

            const parsedTabs = JSON.parse(tbs)
            const parsedSelectedTab = JSON.parse(sltbs)

            setTabs(JSON.parse(tbs))
            setButtons(JSON.parse(swbts))
            setTabIndex(JSON.parse(tabIndx))

            // Verificar se o selectedTab existe nas tabs disponíveis
            const tabExists = parsedSelectedTab === 'menu' ||
                parsedTabs.some(t => t.value === parsedSelectedTab)

            if (tabExists) {
                setSelectedTab(parsedSelectedTab)
            } else {
                setSelectedTab('menu')
                sessionStorage.setItem('selectedTab', JSON.stringify('menu'))
            }
        }
    }, [])

    useEffect(() => {
        if (isFirstTime === true) {
            setTimeout(() => {
                setSelectedTab("menu")
                setShowMenu(true)
                navigate(`/home`)
                setButtons(true)
                setIsFirstTime(false)
            }, 50)
        } else {
            sessionStorage.setItem('tabs', JSON.stringify(tabs))
            sessionStorage.setItem('selectedTab', JSON.stringify(selectedTab))
            sessionStorage.setItem('showButtons', JSON.stringify(showButtons))
            sessionStorage.setItem('tabIndex', tabIndex)
        }
    }, [tabs, selectedTab, showButtons, tabIndex, isFirstTime, navigate])

    const handleChange = (event, newValue) => {
        if (ctx.isLoadingRef?.current) return
        //* was event.target.role
        if (event.target.type) {
            setSelectedTab(newValue)
            sessionStorage.setItem('selectedTab', JSON.stringify(newValue))
            return
        }
    }

    async function versionControl() {
        const newVersion = await fetch('/version.txt')
        const oldVersion = localStorage.getItem('version')
        const versionText = await newVersion.text()

        if (versionText != oldVersion) {
            window.location.reload(true)
            localStorage.setItem('version', versionText)
        }
    }

    const goToPage = (url, passLabel) => {
        versionControl()
        const label = passLabel ? passLabel : url.slice(url.search('/') + 1)
        navigate(`${url}`)
        setButtons(false)

        const newTab = {
            value: `${tabIndex}`,
            label: label,
            tabUrl: `${url}`
        }
        setTabs([...tabs, newTab])
        setSelectedTab(`${tabIndex}`)
        sessionStorage.setItem('selectedTab', JSON.stringify(`${tabIndex}`))
        setTabIndex(tabIndex + 1)
    }

    const handleTabClose = (value, redirectUrl) => {
        sessionStorage.removeItem('lines')
        sessionStorage.removeItem('context')
        sessionStorage.removeItem('contextLine')
        const tabKeys = JSON.parse(sessionStorage.getItem(`tab"${value}"`))
        if (JSON.parse(sessionStorage.getItem(`tab"${value}.1"`))) {
            const tempParentTable = JSON.parse(sessionStorage.getItem(`tab"${value}.1"`))
            if (tempParentTable) {
                tempParentTable.forEach(elem => {
                    sessionStorage.removeItem(`"${value}.1"${elem}`)
                    sessionStorage.removeItem(`tab"${value}.1"`)
                })
            }
            if (JSON.parse(sessionStorage.getItem(`tab"${value}.2"`))) {
                const tempParentTable = JSON.parse(sessionStorage.getItem(`tab"${value}.2"`))
                if (tempParentTable) {
                    tempParentTable.forEach(elem => {
                        sessionStorage.removeItem(`"${value}.2"${elem}`)
                        sessionStorage.removeItem(`tab"${value}.2"`)
                    })
                }
            }
        }

        if (tabKeys) {
            tabKeys.forEach(elem => {
                sessionStorage.removeItem(`"${value}"${elem}`)
                sessionStorage.removeItem(`tab"${value}"`)
            })
        }

        const tabArr = tabs.filter(t => t.value !== value)
        if (tabArr.length === 0) {
            setTabs([])
            menusRoute()
            setSelectedTab('menu')
        } else {
            if (selectedTab === value) {
                if (redirectUrl) {
                    const tab = tabs.find(t => t.tabUrl && t.tabUrl.includes(redirectUrl))
                    if (tab) {
                        setSelectedTab(tab.value)
                        navigate(`/home/${tab.tabUrl}`)
                        setButtons(false)
                        setShowMenu(false)
                    } else {
                        setSelectedTab('menu')
                        menusRoute()
                    }
                } else {
                    setSelectedTab('menu')
                    menusRoute()
                }
            }
            setTabs(tabArr)
        }
        window.scrollTo(0, 0)
    }

    const menusRoute = () => {

        setSelectedTab("menu")
        setShowMenu(true)
        navigate(`/home`)
        setButtons(true)
    }

    const tabsRoutes = (url, event) => {
        if (ctx.isLoadingRef?.current) return
        //* was event.target.role
        if (event.target.type) {
            navigate(`/home/${url}`)
            setButtons(false)
            setShowMenu(false)
        }
    }

    const handleChangeLng = (lng) => {
        i18n.changeLanguage(lng)
        localStorage.setItem("lng", lng)
    }

    const handleSettings = () => {
        // console.log('teste settings')
        setShowMenu(false)
        setMobileMoreAnchorEl(null)
        goToPage('settings', 'SettingsSpan')
    }

    const lastMenus = [
        {
            menuLabel: "SettingsSpan",
            onClick: handleSettings,
            menuIcon: <Settings style={{ color: "var(--color-grey-dark)" }} />
        },
        {
            menuLabel: "LogoutSpan",
            onClick: handleLogout,
            menuIcon: <Logout style={{ color: "var(--color-grey-dark)" }} />
        }
    ]

    const renameTab = (tabId, newLabel) => {
        const updatedTabs = tabs.map(tab => {
            if (tab.value === tabId) {
                return { ...tab, label: newLabel }
            }
            return tab
        })
        setTabs(updatedTabs)
    }

    // Function to collect all filter/state data from sessionStorage for a tab
    const collectTabFilters = (tabValue) => {
        const filterKeys = [
            'metaPair',         // filtros aplicados
            'selectedView',     // view selecionada
            'orderInfo',        // ordenação da tabela
            'pageSize'          // registos por página
        ]
        const filters = {}
        const sessionId = `"${tabValue}"`

        filterKeys.forEach(key => {
            const value = sessionStorage.getItem(`${sessionId}${key}`)
            if (value !== null && value !== 'undefined' && value !== 'null') {
                filters[key] = value
            }
        })

        return Object.keys(filters).length > 0 ? JSON.stringify(filters) : null
    }

    // Function to restore filter/state data to sessionStorage for a tab
    const restoreTabFilters = (tabValue, filtersJson) => {
        if (!filtersJson) return

        try {
            const filters = JSON.parse(filtersJson)
            const sessionId = `"${tabValue}"`

            Object.keys(filters).forEach(key => {
                sessionStorage.setItem(`${sessionId}${key}`, filters[key])
            })
        } catch (e) {
            ctx.toastMessages('error', '', t("ErrorRestoringTabFilters"))
        }
    }

    const handlePinTab = async (tab) => {
        const isPinned = !!tab.dbId

        try {
            if (isPinned) {
                // Unpin
                const response = await unpinTabService.post({ Id: tab.dbId })

                if (response && response.Id) {
                    const updatedTabs = tabs.map(t => {
                        if (t.value === tab.value) {
                            const { dbId, ...rest } = t
                            return rest
                        }
                        return t
                    })
                    setTabs(updatedTabs)
                    sessionStorage.setItem('tabs', JSON.stringify(updatedTabs))
                    ctx.toastMessages('success', '', t("TabUnpinned"))
                }
            } else {
                // Pin
                const pinnedTabsCount = tabs.filter(t => t.dbId).length
                const filters = collectTabFilters(tab.value)
                const record = {
                    PageUrl: tab.tabUrl,
                    Label: tab.label,
                    TabOrder: pinnedTabsCount + 1,
                    Filters: filters
                }

                const response = await pinTabService.post(record)

                if (response && response.Id) {
                    const updatedTabs = tabs.map(t => {
                        if (t.value === tab.value) {
                            return { ...t, dbId: response.Id, filters: response.Filters }
                        }
                        return t
                    })
                    setTabs(updatedTabs)
                    sessionStorage.setItem('tabs', JSON.stringify(updatedTabs))
                    ctx.toastMessages('success', '', t("TabPinned"))
                }
            }
        } catch (error) {
            ctx.toastMessages('error', '', t(isPinned ? "ErrorUnpinningTab" : "ErrorPinningTab"))
        }
    }

    // Drag and drop handlers
    const handleDragStart = (e, tab, index) => {
        setDraggedTab({ tab, index })
        e.dataTransfer.effectAllowed = 'move'
        // Adicionada iimagem transparente de 1x1 para nao mostrar a preview do drag
        const emptyImg = new Image()
        emptyImg.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
        e.dataTransfer.setDragImage(emptyImg, 0, 0)
    }

    const handleDragOver = (e) => {
        e.preventDefault()
        e.dataTransfer.dropEffect = 'move'
    }

    const handleDrop = async (e, targetTab, targetIndex) => {
        e.preventDefault()
        if (!draggedTab || draggedTab.index === targetIndex) {
            setDraggedTab(null)
            return
        }

        // Reorder tabs
        const newTabs = [...tabs]
        const [removed] = newTabs.splice(draggedTab.index, 1)
        newTabs.splice(targetIndex, 0, removed)

        setTabs(newTabs)
        sessionStorage.setItem('tabs', JSON.stringify(newTabs))
        setDraggedTab(null)

        // Save order for pinned tabs only (relative order among pinned tabs)
        const pinnedTabs = newTabs
            .filter(tab => tab.dbId)
            .map((tab, idx) => ({
                Id: tab.dbId,
                TabOrder: idx + 1
            }))

        if (pinnedTabs.length > 0) {
            try {
                await saveOrderService.post(pinnedTabs)
            } catch (error) {
                console.error('Error saving tab order:', error)
            }
        }
    }

    const handleDragEnd = () => {
        setDraggedTab(null)
    }

    // Function to update filters for a pinned tab when filters change
    const updateTabFilters = async (tabValue) => {
        const tab = tabs.find(t => t.value === tabValue)

        if (!tab || !tab.dbId) {
            return
        }

        try {
            const filters = collectTabFilters(tabValue)
            const record = {
                Id: tab.dbId,
                Filters: filters
            }

            await updateFiltersService.post(record)

            // Update local state with new filters
            const updatedTabs = tabs.map(t => {
                if (t.value === tabValue) {
                    return { ...t, filters: filters }
                }
                return t
            })
            setTabs(updatedTabs)
            sessionStorage.setItem('tabs', JSON.stringify(updatedTabs))
        } catch (error) {
            ctx.toastMessages('error', '', t("ErrorUpdatingTabFilters"))
        }
    }

    // Function to check if current tab is pinned
    const isTabPinned = (tabValue) => {
        const tab = tabs.find(t => t.value === tabValue)
        return tab && !!tab.dbId
    }

    const isPinnableUrl = (url) => {
        if (!url) return true
        const urlLower = url.toLowerCase()
        const forbiddenPatterns = ['create', 'edit', 'view', 'crud', 'copy', 'request', 'columnsconfig', 'detail']

        if (forbiddenPatterns.some(pattern => urlLower.includes(pattern))) return false
        if (urlLower.includes('approve') && !urlLower.includes('list')) return false

        return true
    }

    const openLeavingModal = (onConfirm) => {
        if (typeof onConfirm === 'function') {
            leavingActionRef.current = onConfirm
        } else {
            const currentTab = selectedTab
            leavingActionRef.current = () => {
                if (currentTab && currentTab !== 'menu') {
                    handleTabClose(currentTab)
                }
            }
        }
        setIsLeavingModalOpen(true)
    }

    const closeLeavingModal = () => {
        setIsLeavingModalOpen(false)
        leavingActionRef.current = null
    }

    const confirmLeavingModal = async () => {
        if (leavingActionRef.current) {
            await Promise.resolve(leavingActionRef.current())
        }
    }

    return (
        <NavigateContext.Provider value={{
            newTab: goToPage,
            closeTab: handleTabClose,
            renameTab: renameTab,
            updateTabFilters: updateTabFilters,
            isTabPinned: isTabPinned,
            openLeavingModal: openLeavingModal,
            closeLeavingModal: closeLeavingModal,
            setTabPinnable: (pinnable) => {
                setTabs(prev => prev.map(t => t.value === selectedTab ? { ...t, isModePinnable: pinnable } : t))
            }
        }}>
            <Grid container className='divTabs'>
                <Grid item xs={12} sm={12} md={12} lg={1.5} >
                    <div className="buttonsDiv">
                        <M_Button
                            none
                            width={'0px'}
                            tooltip={'Home'}
                            icon={<img style={{ width: '190px' }} src="/images/Webtrans.png" alt="home" />}
                            onClick={menusRoute}
                        />
                    </div>
                </Grid>
                <Grid item xs={2.5} sm={2} md={2} lg={.5}>
                    <div className="divFavoritesAndAccount">
                        <M_Button
                            none
                            hoverEffect
                            tooltip={'Menu'}
                            icon={open ? <i className="buttonFavorites pi pi-list"></i> : <i className="buttonFavorites pi pi-bars"></i>}
                            onClick={() => { setShowMenu(!showMenu) }}
                        />
                    </div>
                </Grid>
                <Grid item xs={6.5} sm={7} md={7} lg={9}>
                    <TabContext value={selectedTab}>
                        <TabList
                            scrollButtons={tabs.length > 0 ? 'auto' : false}
                            allowScrollButtonsMobile
                            TabIndicatorProps={{ style: { display: "none", } }}
                            className="tabList"
                            onChange={handleChange}
                            aria-label="Dynamic Tabs"
                            variant="scrollable"
                        >
                            <Tab value="menu" disableRipple={true} className="selectedTabDefault" />
                            {tabs.map((tab, index) => {
                                const isPinned = !!tab.dbId

                                return (
                                    <Tab
                                        draggable={true}
                                        onDragStart={(e) => handleDragStart(e, tab, index)}
                                        onDragOver={handleDragOver}
                                        onDrop={(e) => handleDrop(e, tab, index)}
                                        onDragEnd={handleDragEnd}
                                        onClick={(event) => {
                                            tabsRoutes(tab.tabUrl, event)
                                        }}
                                        onMouseDown={(event) => {
                                            if (event.button === 1) {
                                                document.body.onmousedown = e => { if (e.button === 1) return false; }
                                                handleTabClose(tab.value)
                                            }
                                        }}
                                        disableRipple={true}
                                        key={index}
                                        label={t(tab.label)}
                                        value={tab.value}
                                        icon={
                                            <>
                                                {((isPinnableUrl(tab.tabUrl) && tab.isModePinnable !== false) || isPinned) && (
                                                    <M_Button
                                                        none
                                                        icon={isPinned ? <PushPinIcon fontSize='5px' sx={{ transform: 'rotate(+45deg)' }} /> : <PushPinOutlinedIcon fontSize='5px' sx={{ transform: 'rotate(+45deg)' }} />}
                                                        onClick={() => handlePinTab(tab)}
                                                    />
                                                )}
                                                {!isPinned && (
                                                    <M_Button
                                                        none
                                                        icon={<CloseIcon fontSize='5px' />}
                                                        onClick={() => handleTabClose(tab.value)}
                                                    />
                                                )}
                                            </>
                                        }
                                        iconPosition="end"
                                    />
                                )
                            })}
                        </TabList>
                    </TabContext>
                </Grid>
                <Grid item xs={3} sm={3} md={3} lg={1}>
                    <div className="divAccount" style={{ cursor: 'pointer' }} onClick={(event) => { setMobileMoreAnchorEl(event.currentTarget) }}>
                        <Chip
                            style={{ backgroundColor: 'transparent', borderRadius: '10px', color: 'var(--color-white)' }}
                            avatar={
                                <Avatar style={{ fontWeight: 'bold', color: 'var(--color-grey-dark)', backgroundColor: 'var(--color-grey-light)' }} >
                                    {`${accountName.charAt(0)}`}
                                </Avatar>
                            }
                            label={`${accountCompany}`}
                        />
                    </div>
                    <Menu anchorEl={mobileMoreAnchorEl} open={isMobileMenuOpen} onClose={() => setMobileMoreAnchorEl(null)}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                        <div style={{ margin: "5px", backgroundColor: 'white', width: '220px', height: "220px", }}>
                            {lastMenus.map((menu, key) => (
                                <ListItem component="div" disablePadding key={key}
                                    sx={{ "& .MuiListItemButton-root:hover ": { backgroundColor: 'transparent' } }}
                                >
                                    <ListItemButton sx={{ height: 40, cursor: 'cursor', maxWidth: '220px' }} disableRipple onClick={() => `${menu?.onClick()}`}>
                                        <ListItemText primary={`${t(menu?.menuLabel)}`} primaryTypographyProps={{ color: "var(--color-grey-dark)", fontWeight: "bold" }} />
                                    </ListItemButton>
                                    <Tooltip title={`${t(menu?.menuLabel)}`} placement="right">
                                        <IconButton size="large" disableRipple={true} onClick={() => `${menu?.onClick()}`}
                                            sx={{
                                                "& svg": {
                                                    color: "rgba(255,255,255,0.8)",
                                                    transition: "0.2s",
                                                    transform: "translateX(0) rotate(0)",
                                                },
                                                "&:hover, &:focus": {
                                                    bgcolor: "unset",
                                                    "& svg:first-of-type": { transform: "translateX(-4px) rotate(-20deg)" },
                                                    "& svg:last-of-type": { right: 0, opacity: 1 }
                                                },
                                                "&::after": {
                                                    content: '""',
                                                    position: "absolute",
                                                    height: "80%",
                                                    display: "block",
                                                    left: 0,
                                                    width: "1px",
                                                    bgcolor: "divider",
                                                },
                                            }}
                                        >
                                            {menu?.menuIcon}
                                            <ArrowRight
                                                style={{ color: "var(--color-grey-dark)" }}
                                                sx={{ position: "absolute", right: 4, opacity: 0 }}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                </ListItem>
                            ))}
                            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', marginTop: '5px', marginBottom: '5px' }}>
                                <Tooltip title={"EN"} placement="top">
                                    <img style={{ marginRight: '10px', cursor: 'pointer' }} onClick={() => handleChangeLng("en")} src='/icons/flagIcons/EN.png' alt="EN" width="40px" />
                                </Tooltip>
                                <Tooltip title={"ES"} placement="top">
                                    <img style={{ cursor: 'pointer' }} onClick={() => handleChangeLng("es")} src='/icons/flagIcons/ES.png' alt="ES" width="40px" />
                                </Tooltip>
                                <Tooltip title={"PT"} placement="top">
                                    <img style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={() => handleChangeLng("pt")} src='/icons/flagIcons/PT.png' alt="PT" width="40px" />
                                </Tooltip>
                                <Tooltip title={"FR"} placement="top">
                                    <img style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={() => handleChangeLng("fr")} src='/icons/flagIcons/FR.png' alt="FR" width="40px" />
                                </Tooltip>
                                <Tooltip title={"IT"} placement="top">
                                    <img style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={() => handleChangeLng("it")} src='/icons/flagIcons/IT.png' alt="IT" width="40px" />
                                </Tooltip>
                                <Tooltip title={"DE"} placement="top">
                                    <img style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={() => handleChangeLng("de")} src='/icons/flagIcons/DE.png' alt="DE" width="40px" />
                                </Tooltip>
                                <Tooltip title={"JP"} placement="top">
                                    <img style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={() => handleChangeLng("jp")} src='/icons/flagIcons/JP.png' alt="JP" width="40px" />
                                </Tooltip>
                            </div>
                            <div style={{ height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderTop: '1px solid var(--color-grey)', fontWeight: 'bold', color: 'var(--color-grey-dark)' }} >
                                <span style={{ width: '215px', textAlign: 'center' }}> {accountName} | {accountCompany} </span>
                            </div>
                        </div>
                    </Menu>
                </Grid>
                <M_LateralMenu
                    handleChangeLng={handleChangeLng}
                    handleLogout={handleLogout}
                    handleSettings={handleSettings}
                    showMenu={showMenu}
                    setShowMenu={setShowMenu}
                    menus={menus}
                    setMenus={setMenus}
                    bodyPage={
                        showButtons && <>
                            {matches ?
                                <div
                                    className="webtransCenter"
                                    style={{ width: '100vw', }}
                                >
                                    <img
                                        style={{ maxHeight: '300px' }}
                                        src="/images/WebtransLogo.png"
                                        alt="WEBTRANS LOGO"
                                    />
                                </div>
                                :
                                <div
                                    className='PSLLayout'
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        overflow: 'hidden',
                                        opacity: 0.5,
                                        width: '100vw',
                                    }} >
                                    <div className="e4414_14511">
                                        <div className="e4414_14506"></div>
                                        <div className="e4414_14507"></div>
                                        <div className="e4414_14508"></div>
                                        <div className="e4414_14509"></div>
                                        <div className="e4414_14510"></div>
                                    </div>
                                </div>
                            }
                        </>

                    }
                />
            </Grid>
            <div className='baseLine'>
                <ScrollToTop
                    smooth
                    component={<ArrowUpwardIcon fontSize="large" style={{ color: 'var(--color-white)' }} />}
                    style={{
                        backgroundColor: `${ctx.primaryColor ? ctx.primaryColor : "var(--color-black)"}`,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '45px',
                        height: '45px'
                    }} />
                <Routes>
                    <Route path='/go/*' element={<Go showButtons={showButtons} onCreateTab={goToPage} roles={roles} tablesOrder={tablesOrder} onTablesOrderUpdate={onTablesOrderUpdate} handleTabClose={handleTabClose} toastMessages={ctx.toastMessages} />} />
                    <Route path='/master/*' element={<Master showButtons={showButtons} onCreateTab={goToPage} roles={roles} tablesOrder={tablesOrder} onTablesOrderUpdate={onTablesOrderUpdate} handleTabClose={handleTabClose} toastMessages={ctx.toastMessages} />} />
                    <Route path='/containerControl/*' element={<ContainerControl showButtons={showButtons} onCreateTab={goToPage} roles={roles} handleTabClose={handleTabClose} toastMessages={ctx.toastMessages} />} />
                    <Route path='/dashboard' element={<DashboardV1 onCreateTab={goToPage} roles={roles} tablesOrder={tablesOrder} onTablesOrderUpdate={onTablesOrderUpdate} handleTabClose={handleTabClose} handleTabClose={handleTabClose} toastMessages={ctx.toastMessages} />} />
                    <Route path='/settings' element={<SettingsPage />} />
                    <Route path='/genericentity/*' element={
                        <GenericEntity 
                            showButtons={showButtons}
                            onCreateTab={goToPage}
                            roles={roles}
                            handleTabClose={handleTabClose}
                            toastMessages={ctx.toastMessages}
                        />
                    } />
                </Routes>
            </div>
            <LeavingPageModal
                open={isLeavingModalOpen}
                onClose={closeLeavingModal}
                onConfirm={confirmLeavingModal}
            />
        </NavigateContext.Provider >
    )
}
